import { EvtHeader } from "components/header";
import EntityForm from "@/modules/organization/entities/crud/form";
import React from "react";

const CreateEntity = () => {
  return (
    <div className="flex-1">
      <EvtHeader title="Create Entity" />
      <div className="p-6 max-w-md">
        <EntityForm />
      </div>
    </div>
  );
};

export default CreateEntity;
